import 'slick-carousel';

export default {
  init() {},
  finalize() {
    if ($('.hp__logos-slider').length) {
      $('.hp__logos-slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        centerMode: false,
      });
    }

    if ($('.latest-news__content-slider').length) {
      $('.latest-news__content-slider').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    $('.header__menu-trigger').on('click', function() {
      if ($('nav').hasClass('active')) {
        $('nav').removeClass('active');
        $(this).removeClass('active');
      } else {
        $('nav').addClass('active');
        $(this).addClass('active');
      }
    });

    $('.whatis-batten__content-table ul li a').on('click', function(e) {
      e.preventDefault();

      var id = $(this).attr('href');
      $('html,body').animate({
        scrollTop: $(id).offset().top,
      });
    });

    $('.our-journey__events-nav li a').on('click', function(e) {
      e.preventDefault();
      var id = $(this).data('id');

      if (id === 'latest') {
        $('html,body').animate({
          scrollTop: $('.our-journey__events-ind:last-of-type').offset().top,
        });
      } else {
        $('html,body').animate({
          scrollTop: $('.our-journey__events-ind:first-of-type').offset().top,
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js